import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/crateMovement'

const crateMovement = axios.create({
  baseURL
})

interceptorsSetup(crateMovement)

export default class CrateMovements {
  static async getTable (movementQuery) {
    const result = await crateMovement.get('/' + movementQuery.siteId, {
      params:
      {
        start: movementQuery.start,
        end: movementQuery.end
      }
    })
    return result.data
  }
  // 'YYYY-MM-DD', or null when the site has never declared anything.
  static async getLastDate (siteId) {
    const result = await crateMovement.get('/last/' + siteId)
    return result.data.date
  }
  // { declaredDays, holidays } as 'YYYY-MM-DD' lists over [start, end], and
  // washingDays as Date.getDay() numbers (0 = Sunday).
  static async getCalendar ({ siteId, start, end }) {
    const result = await crateMovement.get('/calendar/' + siteId, { params: { start, end } })
    return result.data
  }
  // One movement or an array of them (an array is saved whole or not at all).
  static async createMovement (movement) {
    const result = await crateMovement.post('/', movement)
    return result.data
  }
  static async updateMovement (movement) {
    const result = await crateMovement.post('/update', movement)
    return result.data
  }
  static async archiveMovement (movement) {
    const result = await crateMovement.put('/archive/' + movement)
    return result.data
  }
}
